/**
 * Checks whether the given string is a valid absolute URL beginning with `http` or `https`.
 *
 * @deprecated prefer builtin static method `URL.canParse(maybeUrl: string): bool`
 */
export function isUrl(maybeUrl: string): boolean {
  // URL constructor parsing will fail if not a valid URL string
  try {
    const url = new URL(maybeUrl);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Tries to create a URL using the constructor params provided.
 *
 * @param { string | URL } url
 * the url to parse
 *
 * @param { string | URL } [base]
 * the base url to use for relative paths
 *
 * @returns { URL | undefined }
 * `undefined` if the constructor throws an exception, otherwise the parsed `URL`.
 *
 * If a valid url is _required_, use the `URL` constructor directly with a catch block.
 */
export function tryParseUrl(url: string | URL, base?: string | URL): URL | undefined {
  try {
    return new URL(url, base);
  } catch {
    return undefined;
  }
}

export function isInternalUrl(url: URL): boolean {
  return url.host === window.location.host || getSld(url) === 'chronosphere.io';
}

/**
 * @param { URL } url the URL to check
 * @returns the resolved second-level domain (SLD) as a string
 * @example getSld(new URL('https://subdomain.chronosphere.io:443/path/to/resource#section?search=term')); // 'chronosphere.io'
 */
function getSld(url: URL): string;

/**
 * @param { string | URL } url the URL to check
 * @returns the resolved second-level domain (SLD) as a string
 * @example getSld('https://subdomain.chronosphere.io:443/path/to/resource#section?search=term'); // 'chronosphere.io'
 */
function getSld(url: string | URL | undefined): string | undefined;

function getSld(url: string | URL | undefined): string | undefined {
  if (typeof url === 'string') url = tryParseUrl(url);
  if (!url) return undefined;
  const tldStart = url.hostname.lastIndexOf('.');
  const sldStart = url.hostname.lastIndexOf('.', tldStart - 1);
  const sld = url.hostname.slice(sldStart + 1);
  return sld;
}
